import React, { useState, useEffect } from 'react';
 import Footer from './Footer';
 import Header from './Header';
 

 // Make sure you have Font Awesome installed or linked in your public/index.html
 // For example, in public/index.html:
 // <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" integrity="sha512-..." crossorigin="anonymous" referrerpolicy="no-referrer" />
 

 // --- RainBackground Component ---
 const RainBackground = () => {
     const numberOfDrops = 200;
 

     useEffect(() => {
         // Inject dynamic CSS for rain animation if not already present
         if (!document.getElementById('rain-styles')) {
             const styleSheet = document.createElement("style");
             styleSheet.id = "rain-styles";
             styleSheet.type = "text/css";
             styleSheet.innerText = `
                 @keyframes fall {
                     0% {
                         transform: translateY(-100px) scale(0.8);
                         opacity: 0;
                     }
                     20% {
                         opacity: 0.8;
                     }
                     100% {
                         transform: translateY(100vh) scale(1.2);
                         opacity: 0;
                     }
                 }
                 .raindrop {
                     position: absolute;
                     /* Updated to Golden colors */
                     background: linear-gradient(to bottom,
                                 #FFD700 0%, /* Gold */
                                 #DAA520 50%, /* Goldenrod */
                                 rgba(255, 215, 0, 0.2) 100% /* Transparent Gold */
                                 );
                     width: 3px; /* Slightly thicker drop */
                     height: 120px; /* Bigger drop length */
                     border-radius: 50%;
                     animation-name: fall;
                     animation-timing-function: linear;
                     animation-iteration-count: infinite; /* Rain all the time */
                     pointer-events: none; /* Ensure rain doesn't interfere with clicks */
                     will-change: transform, opacity; /* Optimize for animation */
                 }
             `;
             document.head.appendChild(styleSheet);
         }
     }, []);
 

     const generateDrops = () => {
         const drops = [];
         for (let i = 0; i < numberOfDrops; i++) {
             const duration = 2 + Math.random() * 3; // Random duration (2-5s)
             const delay = Math.random() * duration; // Stagger delays for continuous effect
             const left = Math.random() * 100; // Random horizontal position (0-100vw)
             const sizeFactor = 0.7 + Math.random() * 0.6; // Wider size variation for "bigger" drops
 

             drops.push(
                 <div
                     key={i}
                     className="raindrop"
                     style={{
                         left: `${left}vw`,
                         animationDuration: `${duration}s`,
                         animationDelay: `${delay}s`,
                         transform: `scaleY(<span class="math-inline">\{sizeFactor\}\) scaleX\(</span>{sizeFactor * 0.5})`, // ScaleX for fatter drops
                     }}
                 ></div>
             );
         }
         return drops;
     };
 

     return (
         <div style={{
             position: 'fixed',
             top: 0,
             left: 0,
             width: '100%',
             height: '100%',
             overflow: 'hidden',
             zIndex: -1, // Ensure it's behind content
             // Key Change: Set background to transparent
             backgroundColor: 'transparent',
         }}>
             {generateDrops()}
         </div>
     );
 };
 

 // --- PostCard Component (New) ---
 const PostCard = ({ post, getTypeIcon, getFieldIcon, linkStyle }) => {
     // A function to get the base domain from a URL for display
     const getDisplayLink = (url) => {
         try {
             const urlObj = new URL(url);
             return urlObj.hostname;
         } catch (error) {
             return url; // Return original if invalid URL
         }
     };
 

     return (
         <div style={{
             marginBottom: '25px',
             padding: '25px',
             borderRadius: '10px',
             backgroundColor: '#2A2A2A',
             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
             color: '#E0E0E0',
             transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
             cursor: 'pointer', // Indicate it's clickable
         }}
             onMouseEnter={(e) => {
                 e.currentTarget.style.transform = 'translateY(-5px)';
                 e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.5)';
             }}
             onMouseLeave={(e) => {
                 e.currentTarget.style.transform = 'translateY(0)';
                 e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
             }}
             onClick={() => post.postLink ? window.open(post.postLink, '_blank') : {}} // Open link on card click, if link exists
         >
             <h2 style={{
                 color: '#FFA07A', // Royal Orange
                 fontSize: '22px',
                 marginBottom: '15px',
                 paddingBottom: '10px',
                 borderBottom: `1px solid #4169E1`, // Royal Blue
                 display: 'flex',
                 alignItems: 'center',
                 gap: '12px', // Increased gap for icon
                 fontWeight: '600',
             }}>
                 <i className={`${getTypeIcon(post.postType)} fa-lg`}></i> {/* Larger icon */}
                 {post.postType} by {post.createrName}
             </h2>
             {post.postLink ? (
                 <div style={{
                     marginBottom: '12px',
                     fontSize: '16px',
                     color: '#BBBBBB',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '10px', // Increased gap for icon
                 }}>
                     <i className={`${getFieldIcon('Link')} fa-sm`}></i>
                     <strong>Link:</strong>
                     <a href={post.postLink} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                         {getDisplayLink(post.postLink)} {/* Display cleaner link */}
                     </a>
                 </div>
             ) : (
                 <div style={{
                     marginBottom: '12px',
                     fontSize: '16px',
                     color: '#BBBBBB',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '10px',
                 }}>
                     <i className="fas fa-exclamation-triangle fa-sm"></i> {/* Alert icon */}
                     <strong>Link:</strong> No link found
                 </div>
             )}
             <div style={{
                 marginBottom: '12px',
                 fontSize: '16px',
                 color: '#BBBBBB',
                 display: 'flex',
                 alignItems: 'center',
                 gap: '10px', // Increased gap for icon
             }}>
                 <i className={`${getFieldIcon('Category')} fa-sm`}></i>
                 <strong>Category:</strong> {post.category}
             </div>
         </div>
     );
 };
 

 // --- PostDetail Component ---
 const PostDetail = () => {
     const [searchTerm, setSearchTerm] = useState('');
     const [selectedCategory, setSelectedCategory] = useState('All');
     const [selectedType, setSelectedType] = useState('All');
     const [isSearchFocused, setIsSearchFocused] = useState(false);
     const [posts, setPosts] = useState([]); // Initialize posts as an empty array
     const [loading, setLoading] = useState(true); // State for loading indicator
     const [error, setError] = useState(null); // State for error handling
 

     // --- Theme Colors ---
     const royalBlack = '#1A1A1A'; // A deep, rich black
     const royalBlue = '#4169E1'; // A deep, rich blue
     const royalOrange = '#FFA07A'; // A vibrant, soft orange
 

     // --- Global Body Background Effect ---
     useEffect(() => {
         const body = document.body;
         body.style.background = `linear-gradient(135deg, ${royalOrange} 0%, ${royalBlue} 100%)`;
         body.style.minHeight = '100vh'; // Ensure gradient covers full height
         body.style.margin = '0'; // Remove default body margin
         body.style.fontFamily = 'Roboto, sans-serif'; // Apply font globally
 

         // Cleanup function: revert styles when component unmounts
         return () => {
             body.style.background = '';
             body.style.minHeight = '';
             body.style.margin = '';
             body.style.fontFamily = '';
         };
     }, [royalOrange, royalBlue]);
 

     // --- Fetch Data from API ---
     useEffect(() => {
         const fetchPosts = async () => {
             try {
                 const response = await fetch('http://localhost:8090/api/getAllPost');
                 if (!response.ok) {
                     throw new Error(`HTTP error! status: ${response.status}`);
                 }
                 const data = await response.json();
                 // Assuming the actual data is in the 'body' property of the response
                 setPosts(data.body || []);
             } catch (error) {
                 setError(error);
                 console.error("Error fetching posts:", error);
             } finally {
                 setLoading(false);
             }
         };
 

         fetchPosts();
     }, []); // Empty dependency array means this effect runs once after the initial render
 

 

     // --- Styles ---
     const containerStyle = {
         padding: '30px',
         maxWidth: '900px',
         margin: '40px auto',
         // Make the background semi-transparent to allow rain to show through
         backgroundColor: 'rgba(26, 26, 26, 0.8)', // royalBlack with 80% opacity
         color: '#E0E0E0',
         borderRadius: '12px',
         boxShadow: '0 8px 20px rgba(0, 0, 0, 0.4)',
         border: `1px solid ${royalBlue}`,
         position: 'relative',
         zIndex: 1,
         minHeight: 'calc(100vh - 80px)',
         display: 'flex',
         flexDirection: 'column',
         // Basic responsiveness: Adjust padding for smaller screens
         '@media (max-width: 768px)': {
             padding: '20px',
             margin: '20px auto',
             minHeight: 'auto',
         },
         '@media (max-width: 480px)': {
             padding: '15px',
             margin: '10px auto',
         },
     };
 

     const headerStyle = {
         textAlign: 'center',
         color: royalOrange,
         marginBottom: '25px',
         paddingBottom: '10px',
         borderBottom: `1px solid ${royalBlue}`,
     };
 

     const mainHeadingStyle = {
         fontSize: '32px',
         fontWeight: '700',
         marginBottom: '10px',
         textShadow: `2px 2px 4px rgba(0, 0, 0, 0.3)`,
         '@media (max-width: 768px)': {
             fontSize: '28px',
         },
         '@media (max-width: 480px)': {
             fontSize: '24px',
         },
     };
 

     const subHeadingStyle = {
         fontSize: '18px',
         color: '#BBBBBB',
         fontWeight: '400',
         '@media (max-width: 768px)': {
             fontSize: '16px',
         },
         '@media (max-width: 480px)': {
             fontSize: '14px',
         },
     };
 

     const searchAndFilterContainerStyle = {
         marginBottom: '30px',
         display: 'flex',
         flexDirection: 'column',
         gap: '20px',
     };
 

     const searchBarContainerStyle = {
         display: 'flex',
         alignItems: 'center',
         border: '1px solid #c0c0c0',
         borderRadius: '8px',
         padding: '8px 15px',
         boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.05)',
         transition: 'border-color 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
         backgroundColor: '#333333',
     };
 

     const searchBarContainerFocusedStyle = {
         borderColor: royalBlue,
         boxShadow: `0 0 0 3px ${royalBlue}40`,
         backgroundColor: '#4A4A4A',
     };
 

     const searchInputStyle = {
         flexGrow: 1,
         border: 'none',
         outline: 'none',
         fontSize: '16px',
         padding: '4px 0',
         backgroundColor: 'transparent',
         width: '100%',
         color: '#E0E0E0',
     };
 

     const searchIconStyle = {
         color: '#BBBBBB',
         marginRight: '10px',
         fontSize: '18px',
         transition: 'color 0.3s ease',
     };
 

     const searchIconFocusedStyle = {
         color: royalBlue,
     };
 

     const filterGroupStyle = {
         display: 'flex',
         flexWrap: 'wrap',
         gap: '10px',
         alignItems: 'center',
         padding: '10px 0',
         borderBottom: `1px solid ${royalBlack}`,
         paddingBottom: '15px',
         marginBottom: '5px',
         '@media (max-width: 480px)': {
             flexDirection: 'column',
             alignItems: 'flex-start',
         },
     };
 

     const lastFilterGroupStyle = {
         ...filterGroupStyle,
         borderBottom: 'none',
         paddingBottom: '0',
         marginBottom: '0',
     };
 

     const filterLabelStyle = {
         fontWeight: '600',
         color: '#BBBBBB',
         marginRight: '15px',
         fontSize: '16px',
         minWidth: '70px',
         '@media (max-width: 480px)': {
             marginBottom: '10px',
             marginRight: '0',
         },
     };
 

     const filterButtonStyle = {
         padding: '10px 18px',
         border: `1px solid ${royalBlue}`,
         borderRadius: '25px',
         backgroundColor: '#333333',
         color: royalBlue,
         cursor: 'pointer',
         fontSize: '14px',
         fontWeight: '500',
         transition: 'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
         flexShrink: 0,
         '&:hover': {
             backgroundColor: royalBlue,
             color: '#fff',
             boxShadow: `0 3px 10px rgba(65, 105, 225, 0.4)`, // Royal Blue hover shadow
         }
     };
 

     const activeFilterButtonStyle = {
         ...filterButtonStyle,
         background: `linear-gradient(45deg, ${royalBlue}, ${royalOrange})`,
         color: '#fff',
         borderColor: royalBlue,
         boxShadow: `0 3px 10px rgba(0, 0, 0, 0.4)`,
         fontWeight: '600',
     };
 

     const linkStyle = {
         color: royalBlue,
         textDecoration: 'none',
         fontWeight: 'bold',
         transition: 'color 0.2s ease',
         '&:hover': {
             color: royalOrange,
         },
     };
 

     const allCategories = ['All', ...new Set(posts.map(post => post.category))].filter(Boolean); // Collect unique categories
     const allContentTypes = ['All', ...new Set(posts.map(post => post.postType))].filter(Boolean); // Collect unique types
 

     // --- Filtering Logic ---
     const filteredPosts = posts.filter(post => {
         const matchesSearchTerm = post.createrName.toLowerCase().includes(searchTerm.toLowerCase()) ||
             (post.postLink && post.postLink.toLowerCase().includes(searchTerm.toLowerCase())) ||
             post.postType.toLowerCase().includes(searchTerm.toLowerCase()) ||
             post.category.toLowerCase().includes(searchTerm.toLowerCase());
         const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
         const matchesType = selectedType === 'All' || post.postType === selectedType;
 

         return matchesSearchTerm && matchesCategory && matchesType;
     });
 

     // Function to get appropriate icon for content type
     const getTypeIcon = (type) => {
         switch (type) {
             case 'video': return 'fas fa-video';
             case 'website': return 'fas fa-globe';
             case 'PDF': return 'fas fa-file-pdf';
             default: return 'fas fa-cube';
         }
     };
 

     // Function to get icon for specific fields
     const getFieldIcon = (field) => {
         switch (field) {
             case 'Creator Name': return 'fas fa-user';
             case 'Link': return 'fas fa-link';
             case 'Category': return 'fas fa-tags';
             case 'Type': return 'fas fa-file-alt';
             default: return 'fas fa-info-circle';
         }
     };
 

     return (
         <>
             <Header />
             <br />
             <br />
             <br />
             <br />
             <br />
             <br />
 

             <RainBackground />
             <div style={containerStyle}>
                 <header style={headerStyle}>
                     <h1 style={mainHeadingStyle}>Welcome to Girraj Technology</h1>
                     <p style={subHeadingStyle}>Explore Our Curated Tech Content</p>
                 </header>
 

                 <div style={searchAndFilterContainerStyle}>
                     <div
                         style={isSearchFocused ? { ...searchBarContainerStyle, ...searchBarContainerFocusedStyle } : searchBarContainerStyle}
                     >
                         <i
                             className="fas fa-search"
                             style={isSearchFocused ? { ...searchIconStyle, ...searchIconFocusedStyle } : searchIconStyle}
                         ></i>
                         <input
                             type="text"
                             placeholder="Search all content (creator, link, type, category)..."
                             style={searchInputStyle}
                             value={searchTerm}
                             onChange={(e) => setSearchTerm(e.target.value)}
                             onFocus={() => setIsSearchFocused(true)}
                             onBlur={() => setIsSearchFocused(false)}
                         />
                     </div>
 

                     <div style={filterGroupStyle}>
                         <span style={filterLabelStyle}>Filter by Category:</span>
                         {allCategories.map((category) => (
                             <button
                                 key={category}
                                 style={selectedCategory === category ? activeFilterButtonStyle : filterButtonStyle}
                                 onClick={() => setSelectedCategory(category)}
                             >
                                 {category}
                             </button>
                         ))}
                     </div>
 

                     <div style={lastFilterGroupStyle}>
                         <span style={filterLabelStyle}>Filter by Type:</span>
                         {allContentTypes.map((type) => (
                             <button
                                 key={type}
                                 style={selectedType === type ? activeFilterButtonStyle : filterButtonStyle}
                                 onClick={() => setSelectedType(type)}
                             >
                                 {type}
                             </button>
                         ))}
                     </div>
                 </div>
 

                 {loading ? (
                     <p style={{ textAlign: 'center', color: '#BBBBBB', fontSize: '18px', padding: '30px' }}>
                         <i className="fas fa-spinner fa-spin" style={{ marginRight: '10px' }}></i>
                         Loading posts...
                     </p>
                 ) : error ? (
                     <p style={{ textAlign: 'center', color: '#FF6347', fontSize: '18px', padding: '30px' }}>
                         <i className="fas fa-exclamation-circle" style={{ marginRight: '10px' }}></i>
                         Error loading posts: {error.message}. Please ensure the API is running.
                     </p>
                 ) : filteredPosts.length > 0 ? (
                     filteredPosts.map((post) => (
                         <PostCard
                             key={post.id} // Use unique ID from API for key
                             post={post}
                             getTypeIcon={getTypeIcon}
                             getFieldIcon={getFieldIcon}
                             linkStyle={linkStyle}
                         />
                     ))
                 ) : (
                     <p style={{ textAlign: 'center', color: '#BBBBBB', fontSize: '18px', padding: '30px' }}>
                         <i className="fas fa-exclamation-circle" style={{ marginRight: '10px' }}></i>
                         No posts found matching your criteria. Try adjusting your search or filters.
                     </p>
                 )}
             </div>
             <Footer />
         </>
 

     );
 };
 

 export default PostDetail;